import HeroBg from "public/pricingPage/pricingBanner.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Talk to our Team",
    link: "contact-us",
  },
  title: "More Power, Less Cost",
  desc: "OneMind brings you global, reliable infrastructure without the premium price tag. Backed by our 24/7 expert support team, we help you build, scale, and save smarter. Our team ensures you always have the resources you need — when you need them.",
  image: HeroBg,
};
